import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import userSlice from "./slices/userSlice";
import orderSlice from "./slices/orderSlice";
import companySlice from "./slices/companySlice";
import teamMemberSlice from "./slices/teamMemberSlice";
import referralSlice from "./slices/referralSlice";
import offerSlice from "./slices/offerSlice";
import subscriptionPlanSlice from "./slices/subscriptionPlanSlice";
import userSubscriptionSlice from "./slices/userSubscriptionSlice";
import adminPaymentsReducer from "./slices/adminPaymentsSlice";
import threadSlice from "./slices/threadSlice";
import aiWorkflowPlanSlice from "./slices/aiWorkFlowSlice";

const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userSlice,
    order: orderSlice,
    company: companySlice,
    teamMember: teamMemberSlice,
    referral: referralSlice,
    offer: offerSlice,
    subscriptionPlans: subscriptionPlanSlice,
    userSubscriptions: userSubscriptionSlice,
    adminPayments: adminPaymentsReducer,
    thread: threadSlice,
    aiWorkflowPlan: aiWorkflowPlanSlice,
  },
});

export default store;

// INFO: Exporting auth actions and thunks
export {
  logout,
} from "./slices/authSlice";

export {
  clearStaffMemberError,
  clearStaffMemberSuccess,
  resetCurrentStaffMember,
} from "./slices/teamMemberSlice";

export {
  clearOrderChat,
  updateLastMessage,
  updateLastMessageDeliveredToAll,
  updateLastMessageReadByAll,
  participantJoined,
  participantLeft,
  updateThreadInfo,
} from "./slices/orderSlice";

export * from "./thunks/authThunks";
export * from "./thunks/userThunks";
export * from "./thunks/orderThunks";
export * from "./thunks/threadThunks";
export * from "./thunks/companyThunks";
export * from "./thunks/teamMemberThunks";
export * from "./thunks/referralThunks";
export * from "./thunks/offerThunks";
export * from "./thunks/subscriptionPlanThunks";
export * from "./thunks/subscriptionThunks";
export * from "./thunks/paymentThunks";
export * from "./thunks/aiWorkFlowThunks";